// extracted by mini-css-extract-plugin
module.exports = {"container":"Form0_container__1kcPr","header":"Form0_header__1Hj7x","wrapheader":"Form0_wrapheader__MFiRc","body":"Form0_body__1PKSw","box":"Form0_box__MJJGP"};